<template>
	<!---  subStep 0 (category - country - entity) -->
	<div class="register-step-two">
		<h3 class="login-form__title login-form__text-mobile">
			<span v-if="liveAccount" v-html="accountDinamic"></span>
			<span v-if="!liveAccount"> {{ $t('register.startDemo') }} </span>
		</h3>

		<p v-if="liveAccount" class="login-form__subtitle" v-html="$t('register.dinamicDescLive')" @click="changeAccount('live')"></p>
		<p v-if="!liveAccount" class="login-form__subtitle" v-html="$t('register.dinamicDescDemo')" @click="changeAccount('demo')"></p>

		<div>
			<div class="login-form__form">
				<div class="new-user-two">
					<TVInputBase
						id="labelled-field-email-2"
						v-model="emailModel"
						type="email"
						name="labelled-field-email-2"
						:label="$t('register.yourEmail')"
						:placeholder="null"
						:error="emailError"
						style="width: 100%"
						readonly
						disabled
					/>

					<TVInputBase
						id="labelled-field-firstname"
						v-model="firstNameModel"
						type="text"
						name="labelled-field-firstname"
						:label="$t('register.firstName')"
						:placeholder="$t('application.enterFirstName')"
						:error="firstNameError"
						:customErrorMessage="firstNameError"
						style="width: 100%"
					/>

					<TVInputBase
						id="labelled-field-lastname"
						v-model="lastNameModel"
						type="text"
						name="labelled-field-lastname"
						:label="$t('register.lastName')"
						:placeholder="$t('application.enterLastName')"
						:error="lastNameError"
						:customErrorMessage="lastNameError"
						style="width: 100%"
					/>
				</div>

				<CountryEntity
					v-if="entityInputVisible"
					:showCountry="false"
					@updateCountryEntity="updateCountryEntity"
				/>

				<div class="btn-second-start">
					<button
						class="red-button"
						id="btnSubConf"
						@click="registerClicked"
						:disabled="disabled"
					>
						{{ $t('register.getstarted') }}
					</button>
				</div>
			</div>
		</div>

		<!-- Alert -->
		<TVAlert v-if="isShowAlert" :detail="dialogMessageUser" severity="error" />
	</div>
</template>

<script>
import { ref, computed, watch, onMounted } from 'vue'
import { getCurrentInstance } from '@vue/runtime-core'
import TVInputBase from '../../../modules/ui/TVInputBase.vue'
import TVAlert from '../../../modules/global/TVAlert.vue'
import { i18n } from '@/plugins/i18n'
import CountryEntity from '../register/CountryEntity.vue'
import store from '@/store'

export default {
	name: 'Last Step Firstname and Lastname',
	components: {
		TVInputBase,
		CountryEntity,
		TVAlert
	},
	props: {
		liveAccount: Boolean,
		title: String,
		category: String,
		firstName: String,
		lastName: String,
	},
	emits: ['register'],
	setup(props, { emit }) {
		const internalInstance = getCurrentInstance()
		const emitter = internalInstance.appContext.config.globalProperties.emitter

		let emailModel = ref(null)
		let emailError = ref(null)
		let firstNameModel = ref(null)
		let firstNameError = ref(null)
		let isInitialLoad = ref(true)
		let lastNameModel = ref(null)
		let lastNameError = ref(null)
		let entityInputVisible = ref(false)
		let initialEntity = ref(null)
		let entity = ref(null)
		let countryofRecidency = ref(null)
		let isCountryEurope = ref(null)
		let userRegisteredEmitted = ref(false)
		const isShowAlert = ref(false)
		let dialogMessageUser = i18n.global.t('register.reloadPage')

		const accountDinamic = computed(() => {
			const mappings = {
				INDIVIDUAL: i18n.global.t('register.liveIndividual'),
				JOINT: i18n.global.t('register.jointIndividual'),
				CORPORATE: i18n.global.t('register.corporateIndividual'),
			}
			return mappings[props.category] || ''
		})

		const disabled = computed(() => {

			const hasErrors =
				emailError.value?.length > 0 ||
				firstNameError.value?.length > 0 ||
				lastNameError.value?.length > 0

			const isAnyFieldEmpty =
				!emailModel.value || !firstNameModel.value || !lastNameModel.value

			// Deshabilita el botón si hay errores, si algún campo está vacío, o si el disclaimer no está marcado
			return hasErrors || isAnyFieldEmpty
		})

		onMounted(async () => {
			isInitialLoad.value = false
			emailModel.value = store.state.user.email

			if (!emailModel.value || emailModel.value.trim() === "") {
				isShowAlert.value = true
			}
			

			emitter.on('userRegistered', () => {
				userRegisteredEmitted.value = true
				dataEntity() // Execute dataEntity when event is triggered
			})

			// If after a reasonable time the event is not emitted, execute the same dataEntity
			setTimeout(() => {
				if (!userRegisteredEmitted.value) {
					dataEntity()
				}
			}, 2000)
		})

		const isValidName = (name) => {
			// Verificar si el nombre contiene números o caracteres especiales
			const hasNumbers = /\d/.test(name)
			const hasSymbols = /[!@#$%^&*(),.?":{}|<>]/.test(name)
			const hasSpecialChar =
				/[^a-zA-Z\sáéíóúüÁÉÍÓÚÜäößÄÖãõçÇàèìòùÀÈÌÒÙâêîôûÂÊÎÔÛñÑ]/.test(name)
			// El nombre es válido si no tiene números ni caracteres especiales
			return !hasNumbers && !hasSymbols && !hasSpecialChar
		}

		const dataEntity = () => {
			const entityValue = localStorage.getItem('entityValue')
			const migratedUser = localStorage.getItem('migratedUser')

			if ((!entityValue || entityValue === '') && migratedUser === 'false') {
				entityInputVisible.value = true
			} else if (
				entityValue &&
				entityValue !== '' &&
				migratedUser === 'false'
			) {
				entityInputVisible.value = false
			} else if (
				(!entityValue || entityValue === '') &&
				migratedUser === 'true'
			) {
				entityInputVisible.value = false
			} else if (entityValue === null && migratedUser === null) {
				entityInputVisible.value = true
			}
		}

		const registerClicked = () => {
			emit(
				'register',
				emailModel.value,
				firstNameModel.value,
				lastNameModel.value,
			)
		}

		const updateCountryEntity = (data) => {
			countryofRecidency.value = data.countryofRecidency
			entity.value = data.entity
			initialEntity.value = data.initialEntity
			isCountryEurope.value = data.isCountryEurope
		}

		const changeAccount = (type) =>{
			if(type === 'live'){
				window.location.href = '/en/register/1/demo-account'
			}
			if(type === 'demo'){
				window.location.href = '/en/register/1/live-account'
			}
			
		}

		watch(
			() => props.firstName,
			(current, previous) => {
				firstNameModel.value = current
			},
		)

		watch(
			() => props.lastName,
			(current, previous) => {
				lastNameModel.value = current
			},
		)

		// Observador para emailModel
		watch(firstNameModel, (newValue) => {
			if (!isInitialLoad.value) {
				if (!newValue || newValue === '') {
					firstNameError.value = i18n.global.t('register.firstNameError')
				} else if (!isValidName(newValue)) {
					firstNameError.value = i18n.global.t('register.invalidName')
				} else {
					firstNameError.value = false
				}
			}
		})

		// Observador para lastNameModel
		watch(lastNameModel, (newValue) => {
			if (!isInitialLoad.value) {
				if (!newValue || newValue === '') {
					lastNameError.value = i18n.global.t('register.firstNameError')
				} else if (!isValidName(newValue)) {
					lastNameError.value = i18n.global.t('register.invalidLastName')
				} else {
					lastNameError.value = false
				}
			}
		})

		return {
			accountDinamic,
			emailModel,
			emailError,
			isValidName,
			firstNameModel,
			firstNameError,
			lastNameModel,
			lastNameError,
			disabled,
			registerClicked,
			isInitialLoad,
			countryofRecidency,
			initialEntity,
			entity,
			isCountryEurope,
			entityInputVisible,
			updateCountryEntity,
			dataEntity,
			userRegisteredEmitted,
			changeAccount,
			isShowAlert,
			dialogMessageUser
		}
	},
}
</script>
